import React, { FunctionComponent } from 'react';
import { ErrorType } from 'enums';

import './ErrorMessage.scss';

interface IErrorMessageProps {
    type: ErrorType;
    message?: string;
}

export const ErrorMessage: FunctionComponent<IErrorMessageProps> = function ({ type, message }) {
    return (
        <p className="errorMessage">
            {'An error has occurred: '} <br />
            {message}
        </p>
    );
}



